import React, { useState } from "react";
export default function UserProfile() {
    const [isEditing, setIsEditing] = useState(false);
    const [profile, setProfile] = useState({
        name: "Nandha Kumar",
        email: "nandha@email.com",
        phone: "9487924282",
        city: "Erode",
        state: "Tamil Nadu",
        address1: "12 Gandhi Street",
        address2: "Near ABC Mall"
    });
    const handleChange = (e) => {
        setProfile({ ...profile, [e.target.name]: e.target.value, });
    };
    return (
        <div className="profile-page">
            <h2>My Profile</h2>
            <div className="profile-card">
                <div className="profile-avatar">
                    <img src="https://i.pravatar.cc/120" alt="profile" />
                </div>
                <div className="profile-details">
                    {!isEditing ? (
                        <div className="profile-view">
                            <p><strong>Name:</strong> {profile.name}</p>
                            <p><strong>Email:</strong> {profile.email}</p>
                            <p><strong>Phone:</strong> {profile.phone}</p>
                            <p><strong>City:</strong> {profile.city}</p>
                            <p><strong>State:</strong> {profile.state}</p>
                            <p><strong>Address Line 1:</strong> {profile.address1}</p>
                            <p><strong>Address Line 2:</strong> {profile.address2}</p>
                            <button className="edit-profile-btn" onClick={() => setIsEditing(true)}>Edit Profile</button>
                        </div>
                    ) : (
                        <div className="profile-form">
                            <input
                                type="text"
                                name="name"
                                value={profile.name}
                                onChange={handleChange}
                                placeholder="Full Name" />
                            <input
                                type="email"
                                name="email"
                                value={profile.email}
                                onChange={handleChange}
                                placeholder="Email" />
                            <input
                                type="text"
                                name="phone"
                                value={profile.phone}
                                onChange={handleChange}
                                placeholder="Phone" />
                            <input
                                type="text"
                                name="city"
                                value={profile.city}
                                onChange={handleChange}
                                placeholder="City" />
                            <input
                                type="text"
                                name="state"
                                value={profile.state}
                                onChange={handleChange}
                                placeholder="State" />
                            <input
                                type="text"
                                name="address1"
                                value={profile.address1}
                                onChange={handleChange}
                                placeholder="Address Line 1" />
                            <input
                                type="text"
                                name="address2"
                                value={profile.address2}
                                onChange={handleChange}
                                placeholder="Address Line 2" />
                            <div className="profile-actions">
                                <button className="save-btn" onClick={() => setIsEditing(false)}>Save</button>
                                <button className="cancel-btn" onClick={() => setIsEditing(false)}>Cancel</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}